// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"5279":"d0113f3b4c5dae66","7229":"ef905d2196dd9daa","9666":"5440e4dee499c359"}[chunkId] + ".js";
};